<template>
	<div v-html="content.replaceAll('\n', '<br />')" />
</template>

<script>
import api from "@/api"

export default {
	data() {
		return {
			content: null
		}
	},
	methods: {
		async init() {
			let { content } = await api.v1.product.info.get(this.$route.params._product);
			this.content = content;
		}
	},
	async mounted() {
		await this.init();
	}
}
</script>

<style>

</style>